import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=e5224ae2&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5224ae2')) {
      api.createRecord('e5224ae2', component.options)
    } else {
      api.reload('e5224ae2', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=e5224ae2&", function () {
      api.rerender('e5224ae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QzbTU8pD2gYL/JS/offershelp.vue"
export default component.exports